import { functions } from "../firebase";

export type WhatsAppGroupInviteSettings = {
  groupInviteUrl: string;
};

export const getWhatsAppGroupInviteSettings = async (
  communityId: string
): Promise<WhatsAppGroupInviteSettings> => {
  const callable = functions.httpsCallable("getWhatsAppGroupInviteSettings");
  const result = await callable({ communityId });
  return result.data as WhatsAppGroupInviteSettings;
};

export const setWhatsAppGroupInviteSettings = async (params: {
  communityId: string;
  groupInviteUrl: string;
}): Promise<WhatsAppGroupInviteSettings & { ok: true }> => {
  const callable = functions.httpsCallable("setWhatsAppGroupInviteSettings");
  const result = await callable(params);
  return result.data as WhatsAppGroupInviteSettings & { ok: true };
};
